module.exports = __webpack_public_path__ + "static/img/icon2.86d220c6.gif";